import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import volarWhite from '../../../../assets/external-logos/volar-white.svg';
import sevensWhite from '../../../../assets/external-logos/sevens-white.svg';

import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';

type ExternalFooterProps = React.HTMLAttributes<HTMLDivElement>;

const ExternalFooter: React.FC<ExternalFooterProps> = (props) => {
	const currentYear = new Date().getFullYear();

	// Valores por defecto para Sevens Travel - ajustar según datos reales
	const phone = '+598 2903 3434';
	const whatsapp = '59897683318';
	const email = 'hola@sevens.travel';
	const legalName = 'Sevens Travel';
	const addresses = ['Montevideo, Uruguay'];

	return (
		<Box
			component="footer"
			{...props}
			sx={{
				bgcolor: 'grey.900',
				color: 'grey.100',
				p: 4,
				position: 'relative',
				zIndex: 10,
				width: 'auto',
				mx: '-8px',
				mb: '-8px',
			}}
		>
			<Container maxWidth={false} disableGutters sx={{ px: { xs: 2, md: 4 } }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: { xs: 'column', md: 'row' },
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
				>
					<Box sx={{ order: 1, textAlign: { xs: 'center', md: 'left' } }}>
						<Stack spacing={0.5}>
							<Stack direction="row" pb={3} spacing={2} justifyContent={{ xs: 'center', md: 'flex-start' }}>
								<a href={`tel:${phone}`} style={{ color: 'inherit' }}>
									<PhoneIcon />
								</a>
								<a
									href={`https://wa.me/${whatsapp.replace(/\D/g, '')}`}
									target="_blank"
									rel="noopener noreferrer"
									style={{ color: 'inherit' }}
								>
									<WhatsAppIcon />
								</a>
								<a href={`mailto:${email}`} style={{ color: 'inherit' }}>
									<EmailIcon />
								</a>
							</Stack>

							<Typography variant="body2" pt={1} mt={1}>
								{legalName}
							</Typography>

							<Typography variant="body2" mt={1}>
								© {currentYear} Sevens Travel
							</Typography>

							<RouterLink to="/terms" style={{ textDecoration: 'none', color: 'inherit' }}>
								<Typography variant="body2">Términos y Condiciones</Typography>
							</RouterLink>

							<RouterLink to="/privacy" style={{ textDecoration: 'none', color: 'inherit' }}>
								<Typography variant="body2">Política de Privacidad</Typography>
							</RouterLink>
						</Stack>
					</Box>

					<Box
						sx={{
							order: 3,
							ml: { xs: 0, md: 4 },
							mt: 3,
							mb: 0,
							justifyItems: { xs: 'center', md: 'end' },
							display: 'flex',
							flexDirection: 'column',
							height: '100%',
						}}
					>
						{addresses.map((addr, idx) => (
							<Typography key={idx} variant="body2" pb={1} sx={{ alignSelf: 'center' }}>
								<PlaceIcon fontSize="inherit" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
								{addr}
							</Typography>
						))}
						<Box display="flex" alignItems="center" gap={2} mt={2} mb={2} pt={1} pb={1}>
							<img src={volarWhite} alt="Logo Volar" style={{ height: 26 }} />
							<img src={sevensWhite} alt="Logo Sevens" style={{ height: 32 }} />
						</Box>
						<Typography
							variant="body2"
							sx={{
								mt: 'auto',
								pb: '2px',
								fontWeight: 700,
								textAlign: { xs: 'center', md: 'right' },
							}}
						>
							con 💙 Seven&apos;s Travel Group
						</Typography>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

export default ExternalFooter;
